export default __webpack_public_path__ + "static/media/Prokaryotic_Control_DNA.b44d9b61.svg";